import React, { useState ,useEffect } from 'react';
import { useTranslation } from "react-i18next";

import axios from "axios";
import { IoCloseSharp ,TfiFiles} from "../../components/utils/icons";
import { useStateContext } from '../../context/ContextProvider';
import { TextQill, UsersFilter } from './utils';
import { DLabel,  DSpinButton } from '../utils/Form';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Loader, PDFViewer, Pagination } from '../utils';
import { getFillterUsers } from '../../redux/actions/user';
import { BaseUrl } from '../../server';
function CreateCase() {
  const { t } = useTranslation();
  const { currentColor } = useStateContext();
  const [errorMessage, setErrorMessage] = useState("");
  const [isSpinner, setIsSpinner] = useState(false);
  const [caseNumber, setCaseNumber] = useState();
  const [clientName, setClientName] = useState("");
  const [opponentName, setOpponentName] = useState("");
  const [notes, setNotes] = useState("");
  const [clientId, setClientId] = useState("");
  const [caseType,setCaseType ] = useState("");
  const [courtType, setCourtType] = useState("");
  const [courtName, setCourtName] = useState("");
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState("")
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [nextSessionDate ,setNextSessionDate]=useState()
  const [file , setFile]=useState([])
  const [fileShow , setFileShow]=useState([])
  const [hasAccount, setHasAccount] = useState(false); 
const dispatch = useDispatch();
  const { isLoading, FillterUsers, pagination ,totalusers ,errfiter} = useSelector((state) => state.Users);
  const totalPages =pagination?.totalPages
  useEffect(() => {
    if(errfiter){
toast.error(errfiter)
    }
    dispatch(getFillterUsers(page, limit, phoneNumber,email, name));
  }, [page, limit, phoneNumber,email, name,dispatch]);

  const fileHandle = (e) => {
  
    const selectedFiles = Array.from(e.target.files); 
    if (selectedFiles.length === 0) {
      toast.warning(<span className='text-tcolor-4 font-kufi dark:text-tcolor-1 text-sm'>الرجاء اختيار ملف واحد على الأقل</span>);
      setErrorMessage(<span className='font-kufi text-red-500 text-lg'>الرجاء اختيار ملف واحد على الأقل</span>);
      return;
    }


    const invalidFiles = selectedFiles.filter(file => file.type !== "application/pdf");
    
    if (invalidFiles.length > 0) {
      toast.warning(<span className='text-tcolor-4 font-kufi dark:text-tcolor-1 text-sm'>الرجاء اختيار ملفات PDF فقط</span>);
      setErrorMessage(<span className='font-kufi text-red-500 text-sm'>الرجاء اختيار ملفات PDF فقط</span>);
      setFile(null);
      return;
    }

    setErrorMessage("");
    setFile([...file, ...selectedFiles]); 
};


const changefile = (newFiles ,index) => {
  if (newFiles) {
    let tempFile = file;
    tempFile[index] = newFiles;
    
    setFile([...tempFile]);
  
  }
};

const removefile = (index) => {

  const updatedFiles = file.filter((_, i) => i !== index);
  setFile(updatedFiles);
};
const changeUser=(user)=>{
  setClientId(user._id) 
  setClientName(user.name)
}

  const CreateCase = async (newForm) => {
    try {
      const config = { headers: { "Content-Type": "multipart/form-data" } ,withCredentials: true  };
        const { data } = await axios.post(`${BaseUrl}/case/create`, newForm, config );
        if(data.success){
        // عرض رسالة نجاح
        toast.success(<span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">{t("case created successfully!")}</span>);

        // إعادة تعيين الحالات
        setIsSpinner(false);
        setCaseNumber();
        setClientName("");
        setNotes("");
        setNextSessionDate("")
        setOpponentName("");
setFile([])
setFileShow()

      
        }
    } catch (error) {
        // عرض رسالة خطأ
        toast.error(error.response?.data?.message);
        setIsSpinner(false);
    }
};
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSpinner(true);
   

      const newForm = new FormData();
   
        file.forEach((fil) => {
          newForm.append("files", fil);
        });
  
        newForm.append("nextSessionDate", nextSessionDate);
        newForm.append("caseNumber", caseNumber);
        newForm.append("clientName", clientName);
        newForm.append("notes", notes);
        newForm.append("opponentName", opponentName);
        newForm.append("courtType", courtType);
        newForm.append("courtName", courtName);
        newForm.append("caseType", caseType);
        if (clientId){ newForm.append("clientId", clientId);}
       
        
      
       CreateCase(newForm)
   

  };

  return (<>{ isLoading ? ( <Loader/>) :(
        <div className="w-[90%] bg-back-primery lg:w-[50%] m-2 md:m-10 mt-24 p-2 md:p-10  rounded-3xl">
        <h3 className="text-xl font-semibold text-color-1 font-kufi color text-center">
          {t("Create Case")}
        </h3>
        <form onSubmit={handleSubmit}>
          <br />
          <div>
        
          <DLabel
              labelText="case Number"
              value={caseNumber}
              onChange={(e)=> {setCaseNumber(e.target.value)}}
              required={true}
              type="number"
              name="caseNumber"
            />
            <DLabel
              labelText="case Type"
              value={caseType}
              onChange={(e)=> {setCaseType(e.target.value)}}
              required={true}
              type="text"
              name="caseNumber"
            />
            <div className="mb-4">
 
  
  <div className="flex items-center space-x-4 space-x-reverse">
    <label className="inline-flex items-center">
      <input
        type="checkbox"
        checked={hasAccount === true}
        onChange={() => setHasAccount(true)}
        className="form-checkbox h-5 w-5 text-color-1"
      />
      <span className="mr-2 text-sm text-tcolor-5 font-kufi">الموكل لديه حساب</span>
    </label>
    
    <label className="inline-flex items-center">
      <input
        type="checkbox"
        checked={hasAccount === false}
        onChange={() => setHasAccount(false)}
        className="form-checkbox h-5 w-5 text-indigo-600"
      />
      <span className="mr-2 text-sm text-tcolor-5 font-kufi">الموكل ليس لديه حساب</span>
    </label>
  </div>
</div>

{hasAccount === true && <div className="w-full bg-back-secondary flex flex-col items-center justify-center rounded-md p-2">
<UsersFilter name={name} setName={setName} email={email} setEmail={setEmail}  phoneNumber={phoneNumber}  setPhoneNumber={setPhoneNumber}/>
<div className="py-3">
  {FillterUsers && FillterUsers.map((user) => (
    <div key={user._id} className="flex items-center  justify-between mb-2">
       <span className="text-tcolor-5 font-kufi text-sm mx-4 ">{user.name}</span>
      <input
        type="checkbox"
        checked={clientId === user._id}
        onChange={() =>changeUser(user)}
        className="form-checkbox h-5 w-5 text-color-1"
      />
     
    </div>
  ))
  }
        <Pagination
              currentPage={page}
              totalPages={totalPages}
              setPage={setPage}
            />
</div>
  </div>}
             <DLabel
              labelText="client Name"
              value={clientName}
              onChange={(e)=> {setClientName(e.target.value)}}
              required={true}
              type="text"
              name="caseNumber"
            />
             <DLabel
              labelText="opponant Name"
              value={opponentName}
              onChange={(e)=> {setOpponentName(e.target.value)}}
              required={true}
              type="text"
              name="caseNumber"
            />
            <DLabel
              labelText="court Type"
              value={courtType}
              onChange={(e)=> {setCourtType(e.target.value)}}
              required={true}
              type="text"
              name="caseNumber"
            />
               <DLabel
              labelText="court Name"
              value={courtName}
              onChange={(e)=> {setCourtName(e.target.value)}}
              required={true}
              type="text"
              name="caseNumber"
            />
                   
        <DLabel
              labelText="next Session Date"
              value={nextSessionDate}
              onChange={(e)=> {setNextSessionDate(e.target.value)}}
              required={true}
              type="date"
              name="nextSessionDate"
            />
             <div className="relative flex-col items-center  mb-4 h-auto pb-5"><label  className="pb-2 text-tcolor-5 text-md font-kufi">  {t("Write the Notes")}</label>   <TextQill  text={notes} setText={setNotes} /></div>
<label className="pb-2 text-tcolor-5  text-md font-kufi">
                {t("Upload file")}
                <span className="text-red-500">*</span>
              </label>
              <input
                type="file"
                name=""
                id="file-upload"
                className="hidden"
                onChange={fileHandle}
              />
                  {errorMessage && <p className='text-red-500'>{errorMessage}</p>}
                  <div className="grid lg:grid-cols-4 grid-cols-2 md:grid-cols-3 sm:grid-cols-2 sm:gap-4 md:gap-4 xs:gap-4 gap-3 w-full text-color-1 mb-4"> 
                  { file?.length > 0 && file.map((newfile ,i) => (
   <div className="h-[180px] relative">
    <label htmlFor={i}>
    <PDFViewer
     key={i}
     fileName={newfile.name}
     fileUrl={newfile instanceof File &&  URL.createObjectURL(newfile) }
   
   />
    </label>
    <input
      onChange={(e) => changefile(e.target.files[0] ,i)} // تصحيح إلى files[0]
      type="file"
      id="file-upload" // معرف فريد
      className="hidden"
    />
    <span
      onClick={()=>removefile(i)}
      className="p-2 z-10 cursor-pointer hover:shadow-lg hover text-white absolute top-1 right-1 rounded-full"
      style={{ backgroundColor: currentColor }}
    >
      <IoCloseSharp />
    </span>
  </div>
))}
                  <label
    className="flex mt-2 justify-center items-center flex-col h-[180px] cursor-pointer border rounded-lg border-dashed hover:border-indigo-500 w-full text-[#d0d2d6]"
    htmlFor="file-upload" // مطابقة مع المعرف الجديد
    style={{ borderColor: currentColor }}
  >
    <span><TfiFiles size={40} color={currentColor} /></span>
    <span className="text font-kufi text-md" style={{ color: currentColor }}>
      {t("Select file")}
    </span>
  </label>
                  
                  </div>

  



              <input
                onChange={fileHandle}
                className="hidden"
                type="file"
                id="file-upload"
              />
              <br />
          </div>
          <DSpinButton isLoading={isSpinner}>{t("Create")}</DSpinButton>
        </form>
      </div>
  
) } </>);
}

export default CreateCase;